import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import { Link } from "react-router-dom";
import {
  InputGroup,
  InputGroupText,
  Button,
  Grid,
  GridItem,
  PageSection,
  PageSectionVariants,
  Title,
  TextVariants,
  TextContent,
  Text,
  TextInput,
  Level,
  LevelItem,
} from "@patternfly/react-core";
import SearchIcon from "@patternfly/react-icons/dist/js/icons/search-icon";
import UserTable from "../components/user/UserTable";
import { REQUESTED_USERS } from "../redux/actions/userAction";
import { keyValueFilter } from "../utils/filterUtil";

export default () => {
  const mapState = useCallback(
    (state) => ({
      users: state.userState.users,
      isFetchingUsers: state.userState.isFetchingUsers,
    }),
    []
  );

  const [filterValue, setFilterValue] = useState("");
  const { users, isFetchingUsers } = useMappedState(mapState);
  const dispatch = useDispatch();

  const filterUsers = useCallback(() => {
    return keyValueFilter(users, "kerberos", filterValue);
  }, [users, filterValue]);

  useEffect(() => {
    if (!users) {
      dispatch({
        type: REQUESTED_USERS,
        payload: {},
      });
    }
    const filteredUser = filterUsers();
    setFilteredUsers(filteredUser);
  }, [dispatch, users, filterUsers]);

  function handleNameChange(filterValue) {
    setFilterValue(filterValue);
  }

  // filter users
  const [filteredUsers, setFilteredUsers] = useState(users);

  useEffect(() => {
    const filteredUser = filterUsers();
    setFilteredUsers(filteredUser);
  }, [filterValue, filterUsers]);

  function renderUserTables() {
    if (users && filteredUsers && !isFetchingUsers) {
      return (
        <Grid hasGutter>
          <GridItem key={`user-1`} span={12}>
            <UserTable key={`user-1-table`} users={filteredUsers} />
          </GridItem>
        </Grid>
      );
    }
  }

  function renderHeader() {
    if (!users || !filteredUsers || isFetchingUsers) {
      return <div>Loading...</div>;
    } else {
      return (
        <>
          <Title
            headingLevel="h1"
            size="4xl"
            className="pf-c-title--PaddingTop"
          >
            User
          </Title>
          <TextContent>
            <Text component={TextVariants.h2}>Find a user here:</Text>
          </TextContent>
          <Level>
            <LevelItem>
              <InputGroup>
                <TextInput
                  name="user-name-filter"
                  placeholder="Find a user"
                  value={filterValue || ""}
                  type="text"
                  onChange={handleNameChange}
                  aria-label="User filter"
                />
                <InputGroupText component="label" htmlFor="user-name-filter">
                  <SearchIcon />
                </InputGroupText>
              </InputGroup>
            </LevelItem>
            <LevelItem>
              <Link to="/user/create">
                <Button variant="primary" className="button--MarginLeft">
                  Create User
                </Button>
              </Link>
            </LevelItem>
          </Level>
        </>
      );
    }
  }

  function renderBody() {
    if (!users || !filteredUsers || isFetchingUsers) {
      return <div>Loading...</div>;
    } else {
      return renderUserTables();
    }
  }

  return (
    <>
      <PageSection variant={PageSectionVariants.light}>
        {renderHeader()}
      </PageSection>
      <PageSection>{renderBody()}</PageSection>
    </>
  );
};
